import { useState, useEffect } from "react";
import { useAccount, useNetwork } from "wagmi";
import { useToast } from "@chakra-ui/react";

// Configs
import { config } from "config/network";

// Constants
import { SWITCH_NETWORK } from "constants/analytics";

// Utils
import { sentryErrorLog } from "utils/sentryLog";

// Hooks
import useApp from "./useApp";

const useChain = () => {
  const toast = useToast();
  const { track } = useApp();

  const { chain } = useNetwork();
  const { connector } = useAccount();

  const [isValidChainConnected, setValidChainStatus] = useState(false);

  useEffect(() => {
    if (chain) {
      setValidChainStatus(chain.id === +config.chainId);
    } else {
      setValidChainStatus(false);
    }
  }, [chain]);

  const handleSwitch = async () => {
    if (connector) {
      track(SWITCH_NETWORK);
      if (connector.id === "binance") {
        const { BinanceChain } = window as any;
        BinanceChain.switchNetwork(config.network);
      } else if (connector.switchChain) {
        try {
          await connector.switchChain(+config.chainId);
        } catch (error) {
          sentryErrorLog(error);
          toast({
            description: `Error switching network. Try switching in the wallet app first.`,
            status: "error",
            duration: 5000,
            position: "top",
            isClosable: true,
          });
        }
      }
    }
  };

  return { status: isValidChainConnected, switchChain: handleSwitch };
};

export default useChain;
